import { canMailingTo } from 'app/common/ui-next/_filter-compilations/mailing'
import { ReportType } from 'app/dataTypes/reports'
import { GroupedSubsidyFilterKey as FilterKey } from 'app/components/Reports/_Subsidies/Grouped/ReportFilter/filterItems/types'

import { apiStringFromReportType } from '../../../data/_predefined/api-string-from-report-type'
import { ClassType } from 'app/dataProviders/filter-items'

export type ApiSubsidiesGroupedParams = {
  report_type: string
  params: {
    limits: {
      school_id: number,
      year_id: number,
      month: number,
      group_type: 'klasses' | 'day_cares' | 'camp' | null,  // тип класса [klasses, day_cares, camp, null]
      klass_id: number | null,    // id класса
      day_care_id: number | null, // id ГПД
      student_id: number | null,  //
      allowance: string | null    // тип льгот - "Малоимущая семья"
    }
  }
}

const getFormDataFromSelector = (formItem: string, formData: FormData) => {
  const value = formData.getAll(formItem) as Array<string> | undefined
  if (value && value.length) return value
  return []
}

export const convertParams = (formData: FormData): [ApiSubsidiesGroupedParams, null] => {
  const orgID = formData.get(FilterKey.Org) as string
  const schoolYear = formData.get(FilterKey.SchoolYear) as string
  const classType = formData.get(FilterKey.ClassType) as string
  const month = formData.get(FilterKey.Month) as string
  const classesList = getFormDataFromSelector(FilterKey.ClassesList, formData) as Array<string>
  const dayCaresList = getFormDataFromSelector(FilterKey.DayCaresList, formData) as Array<string>
  const studentIds = getFormDataFromSelector(FilterKey.StudentList, formData) as Array<string>
  const allowances = getFormDataFromSelector(FilterKey.Allowances, formData) as Array<string>

  // const email = canMailingTo(formData)
  // const options = email ? { send_to_email: email } : {}
  return [
    {
      report_type: apiStringFromReportType(ReportType.SubsidiesGrouped),
      params: {
        limits: {
          school_id: parseInt(orgID, 10),
          year_id: parseInt(schoolYear, 10),
          month: parseInt(month, 10),
          group_type: classType === 'all' ? null : classType as ClassType,
          klass_id: classesList.length ? parseInt(classesList[0], 10) : null,
          day_care_id: dayCaresList.length ? parseInt(dayCaresList[0], 10) : null,
          student_id: studentIds.length ? parseInt(studentIds[0], 10) : null,
          allowance: allowances.length ? allowances[0] : null,
        },
      },
    },
    null,
  ]
}
